import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import ThemeLoader from "./component/theme-loader";
import reportWebVitals from "./reportWebVitals";
import ReactGA4 from "react-ga4";
import config from "config";

const root = ReactDOM.createRoot(document.getElementById("root"));
ReactGA4.initialize(config.googleAnalytics);
ReactGA4.send({
  hitType: "page-view",
  page: window.location.pathname,
});
root.render(
  <ThemeLoader>
    <BrowserRouter basename="/">
      {/* <GoogleOAuthProvider clientId={config.clientId}> */}
      <App />
      {/* </GoogleOAuthProvider> */}
    </BrowserRouter>
  </ThemeLoader>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
